import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import { HttpHeaders, HttpClient } from '@angular/common/http';
import { environment } from '../../environments/environment';

const httpOptions = {
  headers: new HttpHeaders({ 'Content-Type': 'application/json' })
};

@Injectable()
export class ShareProjectService {
  private URL: string = environment.apiUrl;

  constructor(private http: HttpClient) { }

  shareProject(form: any): Observable<any> {
    return this.http.post(`${this.URL}/shareProject`, form, httpOptions);
  }

  shareImages(form: any): Observable<any> {
    return this.http.post(`${this.URL}/shareImages`, form, httpOptions);
  }

  shareContact(form: any): Observable<any> {
    return this.http.post(`${this.URL}/shareContact`, form, httpOptions);
  }

}



// WEBPACK FOOTER //
// ./src/app/services/share-project.service.ts